import { render } from "./PDP.vue?vue&type=template&id=17b3a920"
import script from "./PDP.vue?vue&type=script&lang=js"
export * from "./PDP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__